import TimerLink from 'components/timer-link/timer-link.component';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { resendVerificationMail } from 'redux/user/user.actions';

const ResendCode = ({ email }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const onResendCodeClick = useCallback(() => {
    dispatch(resendVerificationMail(email));
  }, [dispatch, email]);

  return (
    <TimerLink
      expiry={30}
      onClick={onResendCodeClick}
      label={t('verifyCode.resendCode')}
    />
  );
};

export default ResendCode;
